/**
 * Er tilmeldingsfristen passeret? Samme regel som tenant-sidens widget
 * (apps/holdstyring/.../retreat/_shared/registration.ts) og serveren, der afviser
 * bookingen med 'registration_closed'. Efter fristen må widgetten ikke vise «Book».
 */
export function isRegistrationClosed(
  retreat: { registrationDeadline?: string | null },
  now: number = Date.now(),
): boolean {
  if (!retreat.registrationDeadline) return false
  const deadline = new Date(retreat.registrationDeadline).getTime()
  return Number.isFinite(deadline) && now > deadline
}
